import { render } from "./QuanLyChamCong.vue?vue&type=template&id=0b2c3b6f&scoped=true"
import script from "./QuanLyChamCong.vue?vue&type=script&lang=js"
export * from "./QuanLyChamCong.vue?vue&type=script&lang=js"

import "./QuanLyChamCong.vue?vue&type=style&index=0&id=0b2c3b6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2c3b6f"]])

export default __exports__